module.exports = __webpack_public_path__ + "img/manimg-2.15209b18.png";